// extracted by mini-css-extract-plugin
export var base = "_2a-0";
export var updateBanner = "_2a-1";